/**
 * Created by Reda on 08.09.2026
 */

const SoundFrame = function (bundleName, key, frame) {
    VirtualResource.call(this, bundleName, key);

    this.frame = frame;
};

SoundFrame.prototype = Object.create(VirtualResource.prototype);
SoundFrame.prototype.constructor = SoundFrame;

SoundFrame.prototype.getTexture = function () {
    return bundles[this.bundleName].urls.mp3;
};

SoundFrame.prototype.getUrl = function () {
    return this.getTexture().getUrl();
};

SoundFrame.prototype.getFrameName = function () {
    return this.key;
};

SoundFrame.prototype.save = function () {
    return this.frame;
};
